export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "confirm_customer_iban": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Confirmer l'IBAN du client ", _interpolate(_named("iban"))])},
        "change_customer_iban": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier l'IBAN du client"])},
        "provide_customer_iban": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renseigner l'IBAN du client"])},
        "customer_iban_confirmed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IBAN du client confirmé"])}
      },
      "en": {
        "confirm_customer_iban": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Confirm the customer IBAN ", _interpolate(_named("iban"))])},
        "change_customer_iban": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change the customer IBAN"])},
        "provide_customer_iban": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Provide the customer IBAN"])},
        "customer_iban_confirmed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer IBAN confirmed"])}
      }
    }
  })
}
